import {useEffect} from 'react';
import type {RefObject} from 'react';

import {useStaffCard} from '@yandex-int/react-hooks';
import {useOrganizationUserCard} from '@yandex-data-ui/cloud-components';

import {useStateSelector} from '~ui/hooks';

type StaffCardOptions = {
    login: string;
    uid?: string;
    cloudUid?: string;
};

export function useUserCard(
    anchorRef: RefObject<HTMLElement>,
    {login, uid, cloudUid}: StaffCardOptions,
    enabled = true,
) {
    const {staffHost, appInstallation, isTouch} = useStateSelector((state) => state.global);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const anchor = anchorRef && anchorRef.current;

        if (!anchor) {
            return;
        }

        const title = anchor.getAttribute('title');

        if (title) {
            anchor.removeAttribute('title');
        }

        if (appInstallation === 'business' && cloudUid) {
            // в этом атрибуте useOrganizationUserCard ищет cloudUid
            anchor.dataset.userId = cloudUid;
            anchor.classList.add('UserCard');
        }
    }, [appInstallation, cloudUid, anchorRef, enabled]);

    // TODO надо этот хук натравить на body/g-root ?
    useOrganizationUserCard({
        containerRef: anchorRef,
        selector: ['.UserCard'].join(', '),
        route: '/.user/{userId}',
        disabled: !enabled || isTouch || appInstallation !== 'business',
    });

    useStaffCard(
        {
            anchorRef,
            login,
            uid,
            env: 'yateam',
            from: 'wiki',
            staffOrigin: staffHost,
        },
        enabled && !isTouch && appInstallation === 'intranet',
    );
}
